import {
  AfterTideBook,
  TierMetadata,
  AfterTideAuthor,
  AfterTideSeries,
  AfterTideReview,
} from './aftertideTypes'

export const tierMetadata: Record<number, TierMetadata> = {
  1: {
    level: 1,
    name: 'Mild',
    shortDesc: 'Vanilla romance, light kink, high emotional safety.',
    longDesc:
      'Tier 1 represents the lightest end of the AfterTide spectrum. These stories feature high emotional safety, clear communication, and enthusiastic consent. While they may contain mature themes or light kink, boundaries are strictly respected.',
    color: 'border-amber-500/30',
    badgeColor: 'bg-amber-900/80 text-amber-200 border-amber-700',
    expectations: [
      'Clear communication',
      'Safe words used and respected',
      'High emotional safety',
      'Guaranteed happily ever after',
    ],
    commonWarnings: ['Mild violence', 'Profanity', 'Light bondage'],
  },
  2: {
    level: 2,
    name: 'Moderate',
    shortDesc: 'Established kink, mild power dynamics, safe words used.',
    longDesc:
      'Tier 2 introduces more established power dynamics and kink exploration. Consent remains enthusiastic, but the situations may be more intense. Characters might experience mild peril or emotional turmoil, but the core relationship remains a safe harbor.',
    color: 'border-orange-500/30',
    badgeColor: 'bg-orange-900/80 text-orange-200 border-orange-700',
    expectations: [
      'Established power exchange',
      'Intense emotional situations',
      'Mild peril',
      'Consensual non-consent (CNC) with strict limits',
    ],
    commonWarnings: ['Blood play', 'Impact play', 'Kidnapping (consensual)'],
  },
  3: {
    level: 3,
    name: 'Dark',
    shortDesc: 'Dubious consent, heavy power exchange, moral ambiguity.',
    longDesc:
      'Tier 3 crosses into morally grey territory. Consent may be dubious, manipulated, or coerced. Power dynamics are heavy and often unequal. Characters may make highly questionable choices, and the emotional safety is significantly reduced.',
    color: 'border-red-500/30',
    badgeColor: 'bg-red-900/80 text-red-200 border-red-700',
    expectations: [
      'Dubious or coerced consent',
      'Morally grey protagonists',
      'Heavy power imbalance',
      'Psychological manipulation',
    ],
    commonWarnings: ['Stalking', 'Captivity', 'Blackmail', 'Trauma recovery'],
  },
  4: {
    level: 4,
    name: 'Pitch Black',
    shortDesc: 'Non-consent themes, psychological trauma, villain romance.',
    longDesc:
      'Tier 4 is for readers who want to explore the darkest aspects of romance and erotica. These stories heavily feature non-consent, severe psychological trauma, and unapologetic villains. The line between love and obsession is blurred or non-existent.',
    color: 'border-red-800/50',
    badgeColor: 'bg-red-950 text-red-100 border-red-900',
    expectations: [
      'Non-consent',
      'Severe psychological trauma',
      'Villain gets the girl/guy',
      'No moral redemption required',
    ],
    commonWarnings: ['Torture', 'Severe abuse', 'Mind control', 'Gore'],
  },
  5: {
    level: 5,
    name: 'Extreme',
    shortDesc: 'Taboo, extreme horror erotica, no moral boundaries.',
    longDesc:
      'Tier 5 pushes all boundaries. This is extreme horror erotica where nothing is off-limits. Taboos are broken, and the content is designed to shock and disturb as much as it arouses. Proceed with extreme caution.',
    color: 'border-purple-900/50',
    badgeColor: 'bg-purple-950 text-purple-200 border-purple-800',
    expectations: [
      'Extreme taboos',
      'Horror elements',
      'No guaranteed happy ending',
      'Complete lack of moral boundaries',
    ],
    commonWarnings: [
      'Cannibalism',
      'Necrophilia themes',
      'Extreme gore',
      'Snuff themes',
    ],
  },
}

export const aftertideBooks: AfterTideBook[] = [
  {
    id: 'at1',
    title: 'Velvet Shadows',
    author: 'S.R. Cross',
    authorSlug: 'sr-cross',
    cover:
      'https://images.unsplash.com/photo-1614531341773-3bff8b7cb3fc?w=600&q=80',
    blurb:
      'In the underground city of Oakhaven, vampires rule and humans serve. Elara thought she could hide in the shadows, but Lord Malachi has eyes everywhere. When she is taken as his blood-ward, she must navigate a deadly court where her life—and her soul—are the ultimate prizes.',
    darknessTier: 4,
    consentFramework: 'dubious',
    contentWarnings: [
      { category: 'Violence', items: ['Blood play', 'Captivity', 'Biting'] },
      {
        category: 'Psychological',
        items: ['Manipulation', 'Stockholm Syndrome'],
      },
    ],
    genres: ['Paranormal Romance', 'Dark Fantasy'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Paranormal Romance',
    secondaryGenres: ['Horror'],
    subgenreType: 'crossover',
    displayLabel: 'Paranormal Romance',
    shortLabel: 'Paranormal',
    tropes: ['Enemies to Lovers', 'Vampire/Human', 'Captive/Captor'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 2,
    series: { name: 'Blood of Oakhaven', number: 1 },
    rating: 4.6,
    reviewCount: 1245,
    publishDate: '2023-10-15',
    price: 4.99,
    pages: 342,
  },
  {
    id: 'at2',
    title: 'Neon Nights',
    author: 'J.X. Vance',
    authorSlug: 'jx-vance',
    cover:
      'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?w=600&q=80',
    blurb:
      "In the cyberpunk dystopia of Neo-Veridia, synthetic humans are property. Jax is a rogue synth designed for pleasure, but he wants freedom. When he hacks into the mainframe of the city's most powerful CEO, he gets more than he bargained for—a master who wants to break him, and two other synths who want to share him.",
    darknessTier: 3,
    consentFramework: 'enthusiastic',
    contentWarnings: [
      { category: 'Sexual', items: ['Multiple Partners', 'Exhibitionism'] },
      { category: 'Thematic', items: ['Class disparity', 'Dehumanization'] },
    ],
    genres: ['Sci-Fi Erotica', 'Cyberpunk'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Science Fiction Erotica',
    secondaryGenres: ['Romance'],
    subgenreType: 'crossover',
    displayLabel: 'Sci-Fi Erotica',
    shortLabel: 'SF Erotica',
    tropes: ['Master/Servant', 'Harem/Reverse Harem', 'Rebellion'],
    relationshipType: 'Polyamorous',
    pairingType: 'M/M/M',
    spiceLevel: 5,
    burnLevel: 3,
    rating: 4.3,
    reviewCount: 890,
    publishDate: '2024-01-22',
    price: 5.99,
    pages: 280,
  },
  {
    id: 'at3',
    title: 'The Manor',
    author: 'Evelyn Thorne',
    authorSlug: 'evelyn-thorne',
    cover:
      'https://images.unsplash.com/photo-1519074002996-a69e7ac46a42?w=600&q=80',
    blurb:
      "Blackwood Manor has stood empty for a century, or so the locals say. When historian Clara arrives to catalog its library, she awakens something ancient and hungry. It doesn't just want her body; it wants her mind. A descent into madness where pleasure and terror are indistinguishable.",
    darknessTier: 5,
    consentFramework: 'non-consent',
    contentWarnings: [
      {
        category: 'Horror',
        items: ['Demonic possession', 'Gore', 'Psychological torture'],
      },
      { category: 'Sexual', items: ['Somnophilia', 'Monster anatomy'] },
    ],
    genres: ['Horror Erotica', 'Gothic'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Horror Erotica',
    secondaryGenres: ['Horror'],
    subgenreType: 'crossover',
    displayLabel: 'Horror Erotica',
    shortLabel: 'Horror Erotica',
    tropes: ['Haunted House', 'Monster/Human', 'Corruption'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 5,
    burnLevel: 2,
    rating: 4.8,
    reviewCount: 2100,
    publishDate: '2023-08-05',
    price: 6.99,
    pages: 410,
  },
  {
    id: 'at4',
    title: 'Silk & Steel',
    author: 'Marcus Thorne',
    authorSlug: 'marcus-thorne',
    cover:
      'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=600&q=80',
    blurb:
      'In Victorian London, the Hellfire Club is a place of whispered rumors. Lady Arabella seeks ruin to escape an arranged marriage, and the Duke of Westfall is happy to oblige. A strict exploration of dominance and submission behind closed doors, where safewords are absolute.',
    darknessTier: 2,
    consentFramework: 'enthusiastic',
    contentWarnings: [
      {
        category: 'BDSM',
        items: ['Impact play', 'Bondage', 'Humiliation (consensual)'],
      },
    ],
    genres: ['Historical Romance', 'Erotica'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Historical Romance',
    secondaryGenres: [],
    subgenreType: 'core',
    displayLabel: 'Historical Romance',
    shortLabel: 'Hist Romance',
    tropes: ['Aristocracy', 'Secret Society', 'D/s Dynamics'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 1,
    series: { name: 'The Hellfire Chronicles', number: 1 },
    rating: 4.5,
    reviewCount: 1560,
    publishDate: '2022-11-11',
    price: 3.99,
    pages: 315,
  },
  {
    id: 'at5',
    title: 'Abyssal Depths',
    author: 'Cora Black',
    authorSlug: 'cora-black',
    cover:
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=600&q=80',
    blurb:
      "Marine biologist Dr. Aris Thorne dives too deep and finds a civilization that shouldn't exist. The Leviathan king claims her as his mate. She cannot breathe their water, and she cannot leave his side. A dark tale of adaptation and surrender in the crushing depths of the ocean.",
    darknessTier: 4,
    consentFramework: 'somnophilia',
    contentWarnings: [
      {
        category: 'Thematic',
        items: ['Drowning fears', 'Isolation', 'Body modification'],
      },
      { category: 'Sexual', items: ['Tentacles', 'Breeding kink'] },
    ],
    genres: ['Monster Romance', 'Sci-Fi'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Monster Romance',
    secondaryGenres: ['Science Fiction'],
    subgenreType: 'microgenre',
    displayLabel: 'Monster Romance',
    shortLabel: 'Monster Rom',
    tropes: ['Alien/Human', 'Language Barrier', 'Forced Proximity'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 2,
    rating: 4.2,
    reviewCount: 745,
    publishDate: '2024-02-14',
    price: 4.99,
    pages: 360,
  },
  {
    id: 'at6',
    title: "The Professor's Pet",
    author: 'L.M. Sterling',
    authorSlug: 'lm-sterling',
    cover:
      'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&q=80',
    blurb:
      "At the prestigious St. Jude's Academy, Professor Vance demands perfection. When scholarship student Maya fails her midterm, he offers her an alternative way to earn her grade. A slow-burn exploration of power, discipline, and academic ruin.",
    darknessTier: 3,
    consentFramework: 'mixed',
    contentWarnings: [
      {
        category: 'Power Dynamics',
        items: ['Age gap', 'Teacher/Student', 'Blackmail'],
      },
      { category: 'Psychological', items: ['Degradation', 'Praise kink'] },
    ],
    genres: ['Dark Academia', 'Contemporary'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Dark Romance',
    secondaryGenres: [],
    subgenreType: 'core',
    displayLabel: 'Dark Romance',
    shortLabel: 'Dark Romance',
    refinements: ['Dark Academia'],
    tropes: ['Forbidden Love', 'Strict Rules', 'Good Girl/Bad Man'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 1,
    rating: 4.7,
    reviewCount: 3200,
    publishDate: '2023-05-20',
    price: 5.99,
    pages: 400,
  },
  {
    id: 'at7',
    title: 'Pack Law',
    author: 'Elena Frost',
    authorSlug: 'elena-frost',
    cover:
      'https://images.unsplash.com/photo-1504253163759-c23fccaebb55?w=600&q=80',
    blurb:
      'When the Alpha of the Northern Ridge pack is murdered, his three sons must share the leadership—and the mate he left behind. A brutal, bloody fight for dominance where Sienna is both the prize and the peacemaker.',
    darknessTier: 4,
    consentFramework: 'dubious',
    contentWarnings: [
      {
        category: 'Violence',
        items: ['Gore', 'Pack violence', 'Claiming marks'],
      },
      { category: 'Sexual', items: ['Sharing', 'Knotting', 'Public acts'] },
    ],
    genres: ['Shifter Romance', 'Paranormal'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Paranormal Romance',
    secondaryGenres: ['Horror'],
    subgenreType: 'crossover',
    displayLabel: 'Shifter Romance',
    shortLabel: 'Shifter Rom',
    refinements: ['Why Choose'],
    tropes: ['Why Choose', 'Enemies to Lovers', 'Fated Mates'],
    relationshipType: 'Polyamorous',
    pairingType: 'M/M/M/F',
    spiceLevel: 5,
    burnLevel: 3,
    series: { name: 'Northern Ridge', number: 1 },
    rating: 4.4,
    reviewCount: 1850,
    publishDate: '2023-12-01',
    price: 4.99,
    pages: 380,
  },
  {
    id: 'at8',
    title: 'Sweet Surrender',
    author: 'Mia Rose',
    authorSlug: 'mia-rose',
    cover:
      'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=600&q=80',
    blurb:
      'A gentle introduction to the lifestyle. When bakery owner Lily attends a lifestyle club out of curiosity, she meets Julian, a Dom who believes in patience and aftercare. A story about finding your voice and safely exploring desires.',
    darknessTier: 1,
    consentFramework: 'enthusiastic',
    contentWarnings: [
      {
        category: 'BDSM',
        items: ['Light bondage', 'Spanking', 'Sensory deprivation'],
      },
    ],
    genres: ['Contemporary Romance', 'Erotica'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Contemporary Romance',
    secondaryGenres: [],
    subgenreType: 'core',
    displayLabel: 'Contemporary Romance',
    shortLabel: 'Contemp Romance',
    tropes: ['Billionaire', 'Innocent/Experienced', 'Club Setting'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 3,
    burnLevel: 1,
    rating: 4.1,
    reviewCount: 920,
    publishDate: '2024-03-10',
    price: 3.99,
    pages: 250,
  },
  {
    id: 'at9',
    title: 'Crimson Vows',
    author: 'S.R. Cross',
    authorSlug: 'sr-cross',
    cover:
      'https://images.unsplash.com/photo-1505628346881-b72b27e84530?w=600&q=80',
    blurb:
      "The sequel to Velvet Shadows. Elara has accepted her place at Lord Malachi's side, but the vampire courts are treacherous. To secure their power, they must undergo the Crimson Vow—a ritual of pain and blood that will bind them forever, or destroy them both.",
    darknessTier: 4,
    consentFramework: 'dubious',
    contentWarnings: [
      {
        category: 'Violence',
        items: ['Blood play', 'Ritualistic violence', 'Torture'],
      },
      { category: 'Psychological', items: ['Co-dependency', 'Isolation'] },
    ],
    genres: ['Paranormal Romance', 'Dark Fantasy'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Paranormal Romance',
    secondaryGenres: ['Horror'],
    subgenreType: 'crossover',
    displayLabel: 'Paranormal Romance',
    shortLabel: 'Paranormal',
    tropes: ['Arranged Marriage', 'Vampire/Human', 'Court Intrigue'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 2,
    series: { name: 'Blood of Oakhaven', number: 2 },
    rating: 4.8,
    reviewCount: 850,
    publishDate: '2024-04-05',
    price: 5.99,
    pages: 390,
  },
  {
    id: 'at10',
    title: 'The Auction',
    author: 'Victoria Vane',
    authorSlug: 'victoria-vane',
    cover:
      'https://images.unsplash.com/photo-1501163268664-3fdf329d019f?w=600&q=80',
    blurb:
      "In the criminal underworld, everything has a price. Chloe thought she was paying off her father's debt, but she didn't realize she was the currency. Bought by a ruthless cartel boss, she must learn to survive in a gilded cage.",
    darknessTier: 5,
    consentFramework: 'non-consent',
    contentWarnings: [
      {
        category: 'Thematic',
        items: ['Human trafficking themes', 'Slavery', 'Drug use'],
      },
      { category: 'Violence', items: ['Gun violence', 'Physical abuse'] },
    ],
    genres: ['Mafia Romance', 'Dark Contemporary'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Mafia Romance',
    secondaryGenres: ['Thriller'],
    subgenreType: 'microgenre',
    displayLabel: 'Mafia Romance',
    shortLabel: 'Mafia Romance',
    refinements: ['Dark'],
    tropes: ['Captive/Captor', 'Mafia', 'Age Gap'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 5,
    burnLevel: 3,
    rating: 4.5,
    reviewCount: 2400,
    publishDate: '2023-09-18',
    price: 6.99,
    pages: 420,
  },
  {
    id: 'at11',
    title: 'Starbound',
    author: 'Nova Clarke',
    authorSlug: 'nova-clarke',
    cover:
      'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=600&q=80',
    blurb:
      'Stranded on an ice planet, pilot Kira must rely on the indigenous alien warlord to survive. He will keep her warm, but his price is her absolute submission to his alien customs and biology.',
    darknessTier: 3,
    consentFramework: 'mixed',
    contentWarnings: [
      {
        category: 'Thematic',
        items: ['Survival themes', 'Cultural misunderstanding'],
      },
      { category: 'Sexual', items: ['Alien anatomy', 'Breeding kink'] },
    ],
    genres: ['Sci-Fi Romance', 'Alien Romance'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Sci-Fi Romance',
    secondaryGenres: ['Science Fiction'],
    subgenreType: 'crossover',
    displayLabel: 'Sci-Fi Romance',
    shortLabel: 'Sci-Fi',
    refinements: ['Alien Romance'],
    tropes: ['Stranded', 'Mars Needs Women', 'Enemies to Lovers'],
    relationshipType: 'Monogamous',
    pairingType: 'M/F',
    spiceLevel: 4,
    burnLevel: 2,
    rating: 4.3,
    reviewCount: 1100,
    publishDate: '2024-01-05',
    price: 4.99,
    pages: 310,
  },
  {
    id: 'at12',
    title: 'The Safe Word is Red',
    author: 'Julian Thorne',
    authorSlug: 'julian-thorne',
    cover:
      'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=600&q=80',
    blurb:
      'A comprehensive guide to exploring heavy BDSM dynamics safely. This fictionalized account follows two experienced practitioners as they push their limits in a controlled environment.',
    darknessTier: 2,
    consentFramework: 'enthusiastic',
    contentWarnings: [
      {
        category: 'BDSM',
        items: ['Heavy impact', 'Needle play', 'Breath play'],
      },
    ],
    genres: ['Erotica', 'Contemporary'],
    primaryGenre: 'Romance',
    mainSubgenre: 'Erotic Romance',
    secondaryGenres: [],
    subgenreType: 'core',
    displayLabel: 'Erotic Romance',
    shortLabel: 'Erotic Rom',
    tropes: ['Experienced Partners', 'Exhibitionism'],
    relationshipType: 'Monogamous',
    pairingType: 'M/M',
    spiceLevel: 5,
    burnLevel: 2,
    rating: 4.6,
    reviewCount: 670,
    publishDate: '2023-11-20',
    price: 3.99,
    pages: 280,
  },
]

export const aftertideAuthors: AfterTideAuthor[] = [
  {
    slug: 'sr-cross',
    name: 'S.R. Cross',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80',
    bio: 'S.R. Cross writes dark fantasy and paranormal romance that explores the shadows of human desire. When not writing, they can be found wandering ancient ruins or collecting antique daggers.',
    genres: ['Paranormal Romance', 'Dark Fantasy'],
    tierRange: 'Tiers 3–4',
    litLaunchSlug: 'sr-cross',
  },
  {
    slug: 'jx-vance',
    name: 'J.X. Vance',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80',
    bio: 'J.X. Vance is a pioneer in sci-fi erotica, blending high-tech futures with primal needs. Their work often questions what it means to be human in a synthetic world.',
    genres: ['Sci-Fi Erotica', 'Cyberpunk'],
    tierRange: 'Tiers 3–4',
  },
  {
    slug: 'evelyn-thorne',
    name: 'Evelyn Thorne',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    bio: 'Evelyn Thorne specializes in horror erotica that will keep you awake at night for multiple reasons. She lives in a supposedly haunted Victorian home in New England.',
    genres: ['Horror Erotica', 'Gothic'],
    tierRange: 'Tier 5',
  },
  {
    slug: 'marcus-thorne',
    name: 'Marcus Thorne',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    bio: 'Marcus Thorne brings historical romance to its knees. His meticulous research into Victorian underground societies informs his strict, protocol-heavy BDSM narratives.',
    genres: ['Historical Romance', 'Erotica'],
    tierRange: 'Tier 2',
  },
  {
    slug: 'cora-black',
    name: 'Cora Black',
    avatar:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&q=80',
    bio: 'Cora Black dives deep into monster romance, proving that love—and lust—knows no species. Her background in marine biology heavily influences her abyssal tales.',
    genres: ['Monster Romance', 'Sci-Fi'],
    tierRange: 'Tiers 3–4',
  },
  {
    slug: 'lm-sterling',
    name: 'L.M. Sterling',
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80',
    bio: 'L.M. Sterling writes dark academia with a focus on power dynamics and psychological tension. A former professor, they know exactly what happens behind closed office doors.',
    genres: ['Dark Academia', 'Contemporary'],
    tierRange: 'Tier 3',
  },
  {
    slug: 'elena-frost',
    name: 'Elena Frost',
    avatar:
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&q=80',
    bio: 'Elena Frost rules the shifter romance genre with her brutal, bloody, and intensely passionate pack dynamics. She writes exclusively polyamorous and why-choose relationships.',
    genres: ['Shifter Romance', 'Paranormal'],
    tierRange: 'Tier 4',
  },
  {
    slug: 'mia-rose',
    name: 'Mia Rose',
    avatar:
      'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=400&q=80',
    bio: 'Mia Rose is the queen of gentle exploration. Her stories focus on high emotional safety, enthusiastic consent, and the beautiful vulnerability of submission.',
    genres: ['Contemporary Romance', 'Erotica'],
    tierRange: 'Tier 1',
  },
  {
    slug: 'victoria-vane',
    name: 'Victoria Vane',
    avatar:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80',
    bio: 'Victoria Vane writes unapologetic mafia romance where the villains never seek redemption. Her work is pitch-black and not for the faint of heart.',
    genres: ['Mafia Romance', 'Dark Contemporary'],
    tierRange: 'Tier 5',
  },
  {
    slug: 'nova-clarke',
    name: 'Nova Clarke',
    avatar:
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&q=80',
    bio: 'Nova Clarke takes romance to the stars. Her alien romances explore cultural misunderstandings, survival themes, and entirely new biological imperatives.',
    genres: ['Sci-Fi Romance', 'Alien Romance'],
    tierRange: 'Tier 3',
  },
  {
    slug: 'julian-thorne',
    name: 'Julian Thorne',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    bio: 'Julian Thorne writes instructional, highly realistic BDSM erotica. His work serves as both arousing fiction and a guide to safe, sane, and consensual heavy play.',
    genres: ['Erotica', 'Contemporary'],
    tierRange: 'Tier 2',
  },
]

export const aftertideSeries: AfterTideSeries[] = [
  {
    id: 'blood-of-oakhaven',
    name: 'Blood of Oakhaven',
    authorSlug: 'sr-cross',
    authorName: 'S.R. Cross',
    description:
      'A dark, sweeping saga set in the underground vampire city of Oakhaven. Follow Elara and Lord Malachi as they navigate treacherous court politics, ancient rituals, and a love that borders on obsession.',
    bookIds: ['at1', 'at9'],
    tierRange: 'Tier 4',
  },
  {
    id: 'hellfire-chronicles',
    name: 'The Hellfire Chronicles',
    authorSlug: 'marcus-thorne',
    authorName: 'Marcus Thorne',
    description:
      'Behind the polite society of Victorian London lies the Hellfire Club. This series explores the strict, protocol-heavy relationships of its most prominent members.',
    bookIds: ['at4'],
    tierRange: 'Tier 2',
  },
  {
    id: 'northern-ridge',
    name: 'Northern Ridge',
    authorSlug: 'elena-frost',
    authorName: 'Elena Frost',
    description:
      "The Northern Ridge pack is brutal, bloody, and fiercely loyal. This why-choose series follows the pack's leadership struggles and the intense bonds that hold them together.",
    bookIds: ['at7'],
    tierRange: 'Tier 4',
  },
]

export const aftertideReviews: AfterTideReview[] = [
  {
    id: 'r1',
    bookId: 'at1',
    reviewer: 'DarkRomanceReader99',
    rating: 5,
    date: '2023-11-02',
    content:
      'Absolutely devoured this. The power dynamics are perfectly balanced on that knife edge of dubious consent. Malachi is the perfect morally grey MMC.',
    tierContext: 'Reviewed as a Tier 4 reader',
  },
  {
    id: 'r2',
    bookId: 'at1',
    reviewer: 'VampireLover',
    rating: 4,
    date: '2023-10-20',
    content:
      "The world-building is incredible. The blood play scenes are intense but beautifully written. Can't wait for book 2.",
    tierContext: 'Reviewed as a Tier 3 reader',
  },
  {
    id: 'r3',
    bookId: 'at3',
    reviewer: 'HorrorHound',
    rating: 5,
    date: '2023-09-15',
    content:
      'This is exactly what Tier 5 should be. Genuinely terrifying in parts, incredibly hot in others. The descent into madness is handled so well. Not for the faint of heart!',
    tierContext: 'Reviewed as a Tier 5 reader',
  },
  {
    id: 'r4',
    bookId: 'at4',
    reviewer: 'HistoricalSmut',
    rating: 5,
    date: '2022-12-05',
    content:
      'A masterclass in Tier 2 dynamics. The negotiation of boundaries and the strict adherence to safewords made the intense scenes feel incredibly safe and grounded.',
    tierContext: 'Reviewed as a Tier 2 reader',
  },
  {
    id: 'r5',
    bookId: 'at6',
    reviewer: 'AcademiaAesthetic',
    rating: 4,
    date: '2023-06-10',
    content:
      'The tension in the classroom scenes is palpable. The praise kink elements are top-tier. A great slow burn that really earns its Tier 3 rating by the end.',
    tierContext: 'Reviewed as a Tier 3 reader',
  },
  {
    id: 'r6',
    bookId: 'at8',
    reviewer: 'VanillaPlus',
    rating: 5,
    date: '2024-03-25',
    content:
      'Such a beautiful, gentle introduction to BDSM. Julian is the ultimate care-taking Dom. Perfect for when you want something spicy but emotionally warm.',
    tierContext: 'Reviewed as a Tier 1 reader',
  },
  {
    id: 'r7',
    bookId: 'at10',
    reviewer: 'PitchBlackReader',
    rating: 5,
    date: '2023-10-05',
    content:
      'Victoria Vane pulls no punches. This is brutal, dark, and unapologetic. The MMC is a true villain. Exactly what I want from a Tier 5 mafia romance.',
    tierContext: 'Reviewed as a Tier 5 reader',
  },
  {
    id: 'r8',
    bookId: 'at9',
    reviewer: 'DarkRomanceReader99',
    rating: 5,
    date: '2024-04-10',
    content:
      "An incredible follow-up to Velvet Shadows. The Crimson Vow ritual scene was one of the most intense things I've read this year. S.R. Cross never misses.",
    tierContext: 'Reviewed as a Tier 4 reader',
  },
]
